import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';

import { AboutComponent}        from './about/about.component'
import { MaterialsComponent}    from './materials/materials.component'
import { ContactComponent }     from './contact/contact.component'
import { ServicesComponent }    from './services/services.component'

const routes: Routes = [
  { path: '', redirectTo: 'about', pathMatch: 'full' },
  { path: 'contact', component: ContactComponent },
  { path: 'about', component: AboutComponent },
  { path: 'materials', component: MaterialsComponent },
  { path: 'services', component: ServicesComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts